<template>
  <div class="sb_tools" :class="{ s_active: selected }">
    <button class="sb_tools_help" title="Hulp">
      <span class="sb_tools_help_text">Hulp nodig?</span>
      <SvgIcon icon="questionmark" class="sb_tools_help_icon" title="Help" @click.native="startthisOnboarding" />
    </button>

    <transition name="fade">
      <span class="sb_tools_actions" v-if="selected">
        <button
          class="sb_tools_remove"
          @mouseenter="deleteIcon = 'bin-open'"
          @mouseleave="deleteIcon = 'bin'"
          @click="removeItem(selected)"
          title="Verwijder"
          ref="bin"
        >
          <SvgIcon :icon="deleteIcon" />
        </button>
        <button
          class="sb_tools_rotate_cw"
          @click="rotateObject({ object: selected, angle: -90 })"
          title="Draai tegen klok in"
          ref="rotate_cw"
        >
          <SvgIcon icon="rotate-left" />
        </button>
        <button
          class="sb_tools_rotate_ccw"
          @click="rotateObject({ object: selected, angle: 90 })"
          title="Draai met klok mee"
          ref="rotate_cw"
        >
          <SvgIcon icon="rotate-right" />
        </button>
      </span>
    </transition>

    <transition name="fade">
      <span class="sb_tools_positioning" v-if="selected && topObject">
        <button
          :disabled="topObject === selected"
          title="Breng naar voren"
          @click="
            bringForward(selected);
            setTopObject();
          "
        >
          <SvgIcon icon="bring-forwards" />
        </button>
        <button
          :disabled="topObject !== selected"
          title="Plaats naar achter"
          @click="
            sendToBack(selected);
            setTopObject();
          "
        >
          <SvgIcon icon="bring-backwards" />
        </button>
      </span>
    </transition>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
export default {
  props: ['setToolbar'],
  data() {
    return {
      selected: null,
      deleteIcon: 'bin',
      topObject: null,
    };
  },
  computed: {
    ...mapState('canvas', ['manager']),
  },
  methods: {
    ...mapMutations('canvas', ['bringForward', 'sendToBack', 'removeObject', 'rotateObject']),
    ...mapMutations('design', ['setActiveBackground', 'removeActiveImage']),
    ...mapMutations('onboarding', ['startOnboarding']),
    startthisOnboarding() {
      this.setToolbar(true);
      setTimeout(() => {
        this.startOnboarding();
      }, 400);
    },
    removeItem(item) {
      this.removeObject(item);
      if (item.data.type === 'Background') {
        this.setActiveBackground(null);
      } else if (item.data.type === 'Image') {
        this.removeActiveImage(item.data.id);
      }
      this.deleteIcon = 'bin';
    },
    selectObject(e) {
      if (!e || !e.detail) {
        this.selected = null;
        return;
      }

      if (e.detail !== this.selected) {
        this.selected = e.detail;

        if (this.manager.imageObject && this.manager.textObject) {
          this.setTopObject();
        }
      }
    },
    setTopObject() {
      const objects = this.manager.canvas.getObjects().filter((obj) => obj.selectable);

      //2 items on top are size indicators
      this.topObject = objects[objects.length - 1];
    },
  },
  mounted() {
    window.addEventListener('object:selected', this.selectObject);
    window.addEventListener('background:selected', this.selectObject);
    window.addEventListener('selection:cleared', this.selectObject);
  },
  beforeDestroy() {
    window.removeEventListener('object:selected', this.selectObject);
    window.removeEventListener('background:selected', this.selectObject);
    window.removeEventListener('selection:cleared', this.selectObject);
  },
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_tools {
    position: relative;
    display: flex;
    height: 100%;
    font-size: 1.35rem;
    align-items: center;
    opacity: 1;
    pointer-events: none;
    &.s_active {
      button {
        cursor: pointer;
      }
    }
    @include media('>=medium') {
      font-size: 2rem;
    }
    > * {
      &:last-child {
        margin-right: 0;
      }
      @include media('>=small') {
        margin-right: 0.8rem;
      }
      @include media('>=medium') {
        margin-right: 1rem;
      }
    }
    button {
      pointer-events: all;
      padding: 0;
      margin-right: 0.5rem;
      font-size: inherit;
      cursor: default;
      transition: transform 0.3s;
      font-size: 2rem;

      @include media('>=medium') {
        font-size: 2.6rem;
      }

      &.sb_tools_remove {
        transform: translate(-5px, -3px);
        color: $brand-secondary;
      }

      &:hover:not(.sb_tools_remove) {
        transform: scale(1.05);
      }
      &.sb_tools_help {
        pointer-events: all;
        opacity: 1;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        .sb_tools_help_text {
          position: absolute;
          width: 200%;
          transform: translateY(-100%);
          font-family: 'Indie Flower', cursive;
          font-size: 1rem;
          pointer-events: none;
          user-select: none;
          @include media('<medium') {
            display: none;
          }
        }

        .sb_tools_help_icon {
          width: 1.8rem;
          height: 1.8rem;
          cursor: pointer;

          @include media('>=small') {
            width: 2.2rem;
            height: 2.2rem;
          }

          @include media('>=medium') {
            width: 2.6rem;
            height: 2.6rem;
          }

          > svg {
            width: 100% !important;
            height: 100% !important;
          }
        }
      }
    }
    &_actions {
      display: flex;
      align-items: center;
    }
    &_positioning {
      display: flex;
      align-items: center;

      * {
        font-size: 1.6rem;
      }

      @include media('>=medium') {
        * {
          font-size: 2rem;
        }
      }
    }
  }
}
</style>
